<!-- action apiGetReportsFiles -->
<!-- getter getReportsTypes -->

<template>
  <div>
    <dialog-reports-filter ref="DialogReportsFilter" />

    <v-tabs-items v-model="getCurrentTicketTab">
      <v-tab-item v-for="item in getReportsTypes" :key="item.id">
        <v-data-table :headers="headersReports" :items="getReports">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{getTitleReports}}</v-toolbar-title>
              <v-divider
                  class="mx-4"
                  inset
                  vertical
              ></v-divider>
              <v-spacer></v-spacer>

              <!--            Кнопка настройка фильтар-->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small class="mt-2" outlined fab color="primary" @click="clickReportsFilter" v-bind="attrs" v-on="on">
                    <v-icon>mdi-cog-outline</v-icon>
                  </v-btn>
                </template>
                <span>Настройка фильтра</span>
              </v-tooltip>


            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="downloadReport(item)">
              mdi-download
            </v-icon>
          </template>

        </v-data-table>
      </v-tab-item>
    </v-tabs-items>



<!--    <dialog-add-report ref="DialogAddReport" />-->
<!--    <v-data-table :headers="headersReports" :items="getReports" class="elevation-1">-->
<!--      <template v-slot:top>-->
<!--        <v-toolbar flat>-->
<!--          <v-toolbar-title>Отчеты</v-toolbar-title>-->
<!--          <v-divider class="mx-4" inset vertical></v-divider>-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-btn :disabled="btnSaveAvialable" color="primary" dark class="mb-2" @click="btnSaveReports"> Сохранить </v-btn>-->
<!--        </v-toolbar>-->
<!--      </template>-->

<!--      <template v-slot:[`item.periodicity`]="{ item }">-->
<!--        {{periodicity(item)}}-->
<!--      </template>-->


<!--      <template v-slot:[`item.actions`]="{ item, index }">-->
<!--        <v-icon small class="mr-2" @click="btnEditReport(item, index)"> mdi-pencil </v-icon>-->
<!--      </template>-->

<!--    </v-data-table>-->

  </div>
</template>

<script>

 import {
   mapActions,
   mapGetters,
   mapMutations
 } from "vuex"

// import { eventBus } from "@/main"

// import DialogInfo from "@/components/dialogs/DialogInfo"
//import DialogAddReport from "@/components/dialogs/DialogAddReport";
 import DialogReportsFilter from "@/components/dialogs/DialogReportsFilter.vue";
//import { cloneDeep } from 'lodash'

export default {
  name: "reportsPage",
  components: {
    // DialogAddReport
    DialogReportsFilter
  },

  data() {
    return {
      currentReportTab: undefined,
      headersReports: [
        { text: "Имя файла", value: "fileName" },
        { text: "Дата", value: "date" },
        { text: "Локация", value: "location" },
        { text: "", value: "actions", sortable: false },
      ],


      // beforeReportsChange: "",
      // currentReportsChange: "",
      // headersReports: [
      //   { text: "Отчет", value: "name" },
      //   { text: "Периодичность", value: "periodicity" },
      //   { text: "", value: "actions", sortable: false },
      // ],

    }
  },
  methods: {
    // ...mapActions('app',['apiReportsUpdate']),
     ...mapActions('app',['apiGetReportsFiles', 'apiGetFile']),
    // ...mapMutations('app',['setReports']),
     ...mapMutations('app',['setReportsFilter']),

    async clickReportsFilter(){
      console.log('Настройка фильтра')
      const result = await this.$refs.DialogReportsFilter.show({...this.getReportsFilter})


      if (result.answer === "positive"){
        console.log('dialog', result)
        this.setReportsFilter({
              date1: result.form.date1,
              date2: result.form.date2,
              reportLocations: result.form.reportLocations,
            }
        )
        await this.apiGetReportsFiles(this.getReportsFilter)
      }

    },
    async downloadReport(item){
      console.log('download report', item)
      await this.apiGetFile({fileGUID: item.fileGUID, fileMetatype: item.fileMetatype})
    },

    changeReportTab(item){
      console.log('Report tab change', item)
    },

    // async btnSaveReports(){
    //   await this.apiReportsUpdate({reports: this.getReports})
    //   this.beforeReportsChange = JSON.stringify(this.getReports)
    // },

    // async btnEditReport(item, index){
    //   // console.log('btnEditReport',index)
    //   const result = await this.$refs.DialogAddReport.show({
    //     form: item
    //   })
    //   // console.log(result)
    //   if (result.answer==="positive"){
    //     // console.log('positive')
    //     let oldData = cloneDeep(this.getReports)
    //     oldData[index] = result.form
    //
    //     // console.log(oldData)
    //     //await this.apiReportsUpdate({reports: oldData})
    //     this.setReports(oldData)
    //   }
    // },

    // periodicity(item){
    //   // console.log(item)
    //   let week = []
    //   if (item.mon){ week.push("ПН") }
    //   if (item.tue){ week.push("ВТ") }
    //   if (item.wed){ week.push("СР") }
    //   if (item.thu){ week.push("ЧТ") }
    //   if (item.fri){ week.push("ПТ") }
    //   if (item.sat){ week.push("СБ") }
    //   if (item.sun){ week.push("ВС") }
    //   if (week.length===0){
    //     week.push("Периодичность не задана")
    //   }
    //   return week.join(', ')
    // }


  },
  watch: {
    // getReports(val){
    //   // this.currentReportsChange = JSON.stringify(val)
    // }
  },
  computed: {
    ...mapGetters('app',["getCurrentTicketTab", "getReportsTypes", "getReportsFilesByTabs", "getUserLocations", "getReportsFilter"]),

    getReports(){
      console.log('getReportsFilesByTabs',this.getReportsFilesByTabs)
      const result = this.getReportsFilesByTabs.map(val=>({...val, location: this.getUserLocations.find(item=>item.id===val.locationId).name}))
      console.log('result',result)
      return result
    },

    getTitleReports(){
      console.log('this.getReportsFilter', this.getReportsFilter)
      if (!this.getReportsFilter.date1 && !this.getReportsFilter.date2 && (this.getReportsFilter.locations && this.getReportsFilter.locations.length===0) && (this.getReportsFilter.statuses && this.getReportsFilter.statuses.length===0)){
        return "Без фильтров"
      }
      let period = ((this.getReportsFilter.date1 && this.getReportsFilter.date1!=='') && (this.getReportsFilter.date2 && this.getReportsFilter.date2!=='')) ? `${this.getReportsFilter.date1} - ${this.getReportsFilter.date2}` : "Не выбран"
      let locations = (this.getReportsFilter.reportLocations && this.getReportsFilter.reportLocations.length > 0) ? this.getReportsFilter.reportLocations.map(val=>this.getUserLocations.find(item=>item.id===val).name).join(', '): "Не выбраны"
      return `Период: ${period}, Локации: ${locations}`
    }


    // getReportsByTab(){
    //   console.log('current tab', this.getCurrentTicketTab)
    //   return [{fileName: "Аналитика 20.03.2023.xlsx", date: "20.03.2023", location: "Хабаровск", reportType: "analytics", fileGuid:"123-123-123"}]
    // }

    // ...mapGetters('app',["getReports"]),
    // btnSaveAvialable(){
    //   return this.currentReportsChange===this.beforeReportsChange
    // }


  },
  created() {
    // this.beforeReportsChange = JSON.stringify(this.getReports)
    // this.currentReportsChange= this.beforeReportsChange
  },
  mounted() {
    // console.log('ReportsPage mounted')
  },
}
</script>
